import eventBus from './eventBus';
import userFriendlyMessageConverter from './userFriendlyMessageConverter';
import NotificationStatus from '@/domains/common/typescript/NotificationStatus';
import NotifiedError from '@/domains/common/typescript/NotifiedError';
import type HttpStatusCodeEnum from '@/domains/common/typescript/HttpStatusCodeEnum';
import type { ComponentPublicInstance } from 'vue';

// Callers that catch a NotifiedError know the toast already fired here and must not show a second
// one; any other caught error (a plain Error, a network failure, HttpError, ...) has not been
// notified yet and is the caller's responsibility. See docs/adr/0005-notified-error-marks-toasted-errors.md.
function handleHttpError(code: HttpStatusCodeEnum, message: string, showToast = true): void {
    if (showToast) {
        const userFriendlyMessage = userFriendlyMessageConverter(message);
        eventBus.emit('notification-message', {
            title: userFriendlyMessage,
            status: NotificationStatus.error,
        });
        throw new NotifiedError(message);
    }
    throw new Error(message);
}

function handleRenderError(error: Error, instance: ComponentPublicInstance | null, info: string, showToast = true) {
    if (showToast) {
        eventBus.emit('notification-message', {
            title: error?.message ?? info,
            status: NotificationStatus.error,
        });
    }
}

export { handleHttpError, handleRenderError };
